<input [disabled]="disabled" type="text" class="form-control" placeholder="Skriv namn..."
    [ngModelOptions]="{standalone: true}" [(ngModel)]="searchVirkeskopareText" [ngbTypeahead]="searchVirkeskopare"
    (selectItem)="onSelectVirkeskopare($event)" [resultFormatter]="resultVirkeskopareFormat"
    [inputFormatter]="inputVirkeskopareFormat" maxlength="30" />
<i class="remove glyphicon glyphicon-remove" (click)="delete()" [hidden]="!canDelete()"></i>
<i [raskBusy]="'searchingAnvandare'"></i>
